<div class="container-fluid">

  <h2>Upcoming Session Reminders</h2>
  <h4>
    <span *ngIf="upcomingSessions.length == 0">
      Currently there are no reminders :
    </span>
    {{ previousDate | date:'dd/MM/yyyy' }} - {{ threshold | date:'dd/MM/yyyy' }}
  </h4>

  <div class="card">
    <table class="table" *ngIf="upcomingSessions.length > 0">

      <thead>
      <tr>
        <th>Child Name</th>
        <th>Centre</th>
        <th>Parents Name</th>
        <th>Upcoming Date</th>
      </tr>
      </thead>

      <tbody>
      <tr *ngFor="let data of upcomingSessions">
        <td>{{ data.childName }}</td>
        <td>{{ data.centreName }}</td>
        <td>{{ data.parentsName }}</td>
        <td>{{ data.dateOfAssessment?.toDate() | date:'dd/MM/yyyy' }}</td>
      </tr>
      </tbody>

    </table>
  </div>

</div>
